<ada-card
	#RulesPropertiesCard
	id="RulesPropertiesCard"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
	width="100%"
>
	<ada-text
		id="RulesPropertiesCardHeader"
		data-container-selector="ada-card-header"
		content="Rules Properties"
	></ada-text>
	<ada-container
		data-container-selector="ada-card-body"
		[colCount]="4"
		verticalSpacing="Medium"
		horizontalSpacing="Medium"
		[padding]="defaultCardPadding"
	>
		<!-- Installed Authoring Rule Object -->
		<ng-container *ngIf="'InstalledAuthoringRuleObject' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#InstalledAuthoringRuleObjectLabel
				content="Installed Authoring Rule Object"
				id="InstalledAuthoringRuleObjectLabel"
				inheritingText="This property does not inherit from its parent"
				[canInheritWhenRequired]="true"
				[inheriting]="!currentPropertyObject?.InstalledAuthoringRuleObject"
				[isDisabled]="isDisabled"
				[isRequired]="'InstalledAuthoringRuleObject' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteInstalledAuthoringRuleObject()"
			></ada-authoring-property-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[colSpan]="3"
				[colCount]="2"
			>
				<ada-authoring-rule
					#InstalledAuthoringRule
					id="InstalledAuthoringRule"
					[availableProperties]="availableProperties"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(valueChange)="setObjectPropertyValue('InstalledAuthoringRuleObject', $event)"
				></ada-authoring-rule>
			</ada-container>
		</ng-container>
		<!-- Installable Authoring Rule Object -->
		<ng-container *ngIf="'InstallableAuthoringRuleObject' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#InstallableAuthoringRuleObjectLabel
				id="InstallableAuthoringRuleObjectLabel"
				[canInheritWhenRequired]="true"
				[content]="'Installable Authoring Rule Object'"
				[inheriting]="currentPropertyObject?.InstallableAuthoringRuleObject | inheritPipe : inheritedPropertyObject?.InstallableAuthoringRuleObject"
				[isDisabled]="isDisabled"
				[isRequired]="'InstallableAuthoringRuleObject' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteInstallableAuthoringRuleObject()"
			></ada-authoring-property-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[colSpan]="3"
				[colCount]="2"
			>
				<ada-authoring-rule
					#InstallableAuthoringRule
					id="InstallableAuthoringRule"
					[availableProperties]="availableProperties"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(valueChange)="setObjectPropertyValue('InstallableAuthoringRuleObject', $event)"
				></ada-authoring-rule>
			</ada-container>
		</ng-container>
		<!-- Applicable Rule Object -->
		<ng-container *ngIf="'ApplicableAuthoringRuleObject' | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#ApplicableAuthoringRuleObjectLabel
				id="ApplicableAuthoringRuleObjectLabel"
				[canInheritWhenRequired]="true"
				[content]="'Applicable Authoring Rule Object'"
				[inheriting]="currentPropertyObject?.ApplicableAuthoringRuleObject | inheritPipe : inheritedPropertyObject?.ApplicableAuthoringRuleObject"
				[isDisabled]="isDisabled"
				[isRequired]="'ApplicableAuthoringRuleObject' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteApplicableRuleObject()"
			></ada-authoring-property-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[colSpan]="3"
				[colCount]="2"
			>
				<ada-authoring-rule
					#ApplicableRule
					id="ApplicableRule"
					[availableProperties]="availableProperties"
					[isDisabled]="isDisabled"
					[serverObject$]="serverObject$"
					(valueChange)="setObjectPropertyValue('ApplicableAuthoringRuleObject', $event)"
				></ada-authoring-rule>
			</ada-container>
		</ng-container>
		<!-- InstallPathSensorExpression -->
		<ng-container *ngIf="'InstallPathSensorExpression'  | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#InstallPathSensorExpressionLabel
				id="InstallPathSensorExpressionLabel"
				[content]="'Install Path Sensor Expression'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[isRequired]="'InstallPathSensorExpression' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[canInheritWhenRequired]="true"
				[inheriting]="currentPropertyObject?.InstallPathSensorExpression | inheritPipe:inheritedPropertyObject?.InstallPathSensorExpression"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteInstallPathSensorExpression()"
			></ada-authoring-property-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[colSpan]="3"
				[colCount]="2"
			>
				<ada-expression-language-editor
					#InstallPathSensorExpressionEditor
					id="InstallPathSensorExpressionEditor"
					[customCompletionItems]="availableProperties"
					[expression]="!(currentPropertyObject?.InstallPathSensorExpression | inheritPipe) ? currentPropertyObject.InstallPathSensorExpression : inheritedPropertyObject?.InstallPathSensorExpression"
					[isDisabled]="isDisabled"
					[objectId]="(serverObject$ | async)?.objectId"
					[overridesClassName]="editorClass.className"
					[propertyMap]="serverObject$ | async | adaSerializedPropertyMap"
					(expressionChange)="setObjectPropertyValue('InstallPathSensorExpression', $event)"
				></ada-expression-language-editor>
			</ada-container>
		</ng-container>
		<!-- InstalledVersion -->
		<ng-container *ngIf="'InstalledVersion'  | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#InstalledVersionLabel
				id="InstalledVersionLabel"
				[content]="'Installed Version Sensor Expression'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[isRequired]="'InstalledVersion' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[canInheritWhenRequired]="true"
				[inheriting]="currentPropertyObject?.InstalledVersion | inheritPipe:inheritedPropertyObject?.InstalledVersion"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('InstalledVersion'); InstalledVersionEditor.setValue('')"
			></ada-authoring-property-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[colSpan]="3"
				[colCount]="2"
			>
				<ada-expression-language-editor
					#InstalledVersionEditor
					id="InstalledVersionEditor"
					[customCompletionItems]="availableProperties"
					[expression]="!(currentPropertyObject?.InstalledVersion | inheritPipe) ? currentPropertyObject.InstalledVersion : inheritedPropertyObject?.InstalledVersion"
					[isDisabled]="isDisabled"
					[objectId]="(serverObject$ | async)?.objectId"
					[overridesClassName]="editorClass.className"
					[propertyMap]="serverObject$ | async | adaSerializedPropertyMap"
					(expressionChange)="setObjectPropertyValue('InstalledVersion', $event)"
				></ada-expression-language-editor>
			</ada-container>
		</ng-container>
		<!-- UninstallableSensorExpression -->
		<ng-container *ngIf="'UninstallableSensorExpression'  | displayAuthoringProperty: editorClass:propertyConstructor.namespace">
			<ada-authoring-property-label
				#UninstallableSensorExpressionLabel
				id="UninstallableSensorExpressionLabel"
				[content]="'Uninstallable Sensor Expression'"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				[isRequired]="'UninstallableSensorExpression' | isRequiredProperty: editorClass: propertyConstructor.namespace"
				[canInheritWhenRequired]="true"
				[inheriting]="currentPropertyObject?.UninstallableSensorExpression | inheritPipe:inheritedPropertyObject?.UninstallableSensorExpression"
				[isDisabled]="isDisabled"
				(inheritanceChange)="deleteObjectPropertyValue('UninstallableSensorExpression'); UninstallableSensorExpressionEditor.setValue('')"
			></ada-authoring-property-label>
			<ada-container
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				[colSpan]="3"
				[colCount]="2"
			>
				<ada-expression-language-editor
					#UninstallableSensorExpressionEditor
					id="UninstallableSensorExpressionEditor"
					[customCompletionItems]="availableProperties"
					[expression]="!(currentPropertyObject?.UninstallableSensorExpression | inheritPipe) ? currentPropertyObject.UninstallableSensorExpression : inheritedPropertyObject?.UninstallableSensorExpression"
					[isDisabled]="isDisabled"
					[objectId]="(serverObject$ | async)?.objectId"
					[overridesClassName]="editorClass.className"
					[propertyMap]="serverObject$ | async | adaSerializedPropertyMap"
					(expressionChange)="setObjectPropertyValue('UninstallableSensorExpression', $event)"
				></ada-expression-language-editor>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
